import { render, staticRenderFns } from "./searchCertificated.vue?vue&type=template&id=21ea7b16&"
import script from "./searchCertificated.vue?vue&type=script&lang=js&"
export * from "./searchCertificated.vue?vue&type=script&lang=js&"
import style0 from "./searchCertificated.vue?vue&type=style&index=0&id=21ea7b16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports